import React from 'react';
import { Section } from './Shared';
export function Solution() {
  return <div className="bg-sage text-center" data-id="element-229">
      <Section className="!py-20" data-id="element-230">
        <h2 className="font-playfair text-3xl md:text-5xl text-charcoal font-medium leading-tight max-w-4xl mx-auto mb-6" data-id="element-231">
          No necesitás dejarlo llorar para que duerma mejor
        </h2>
        <p className="text-xl md:text-2xl text-white/90 font-medium max-w-2xl mx-auto" data-id="element-232">
          Existe una forma respetuosa que sí funciona
        </p>
      </Section>
    </div>;
}